export const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
  'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain',
  'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria',
  'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
  'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czechia',
  'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominica',
  'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
  'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
  'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea',
  'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India',
  'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica',
  'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos',
  'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania',
  'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta',
  'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia',
  'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria',
  'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau',
  'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines',
  'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis',
  'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino',
  'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia',
  'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan',
  'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
  'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia',
  'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu',
  'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
]

const matchCountry = (name) => {
  const n = String(name || '').trim()
  if (!n) return ''
  const hit = COUNTRIES.find(item => item.toLowerCase() === n.toLowerCase())
  if (hit) return hit
  const aliases = {
    'united states of america': 'United States',
    usa: 'United States',
    'u.s.a.': 'United States',
    'u.s.': 'United States',
    uk: 'United Kingdom',
    'great britain': 'United Kingdom',
    uae: 'United Arab Emirates',
    'south korea': 'South Korea',
    'korea, republic of': 'South Korea',
    'russian federation': 'Russia',
    'czech republic': 'Czechia',
    'viet nam': 'Vietnam',
    'cote d\'ivoire': 'Ivory Coast',
    "côte d'ivoire": 'Ivory Coast'
  }
  return aliases[n.toLowerCase()] || n
}

const countryFromBrowser = () => {
  try {
    const locale = String(navigator.language || Intl.DateTimeFormat().resolvedOptions().locale || '')
    const code = (locale.split('-')[1] || locale.split('-')[0] || '').toUpperCase()
    if (code.length === 2 && typeof Intl.DisplayNames === 'function') {
      const name = new Intl.DisplayNames(['en'], { type: 'region' }).of(code)
      return matchCountry(name)
    }
  } catch (err) {}
  return ''
}

export const detectCountry = async () => {
  const read = async (url, pick) => {
    const res = await fetch(url)
    if (!res.ok) return ''
    const data = await res.json()
    return matchCountry(pick(data))
  }
  try {
    const name = await read('https://ipwho.is/', data => (data && data.success === false ? '' : data.country))
    if (name) return name
  } catch (err) {}
  try {
    const name = await read('https://ipapi.co/json/', data => data && data.country_name)
    if (name) return name
  } catch (err) {}
  return countryFromBrowser()
}
